module.exports = __webpack_public_path__ + "static/img/czgzLogoN.67fd0ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/czgzLogoN.png
// module id = FuIk
// module chunks = 2